import { ActiveTour } from '../../redux/types.ts';

type Tour = { items: string[]; tooltipMapping: number[] };

export const tasks: Record<ActiveTour, Tour> = {
  analysisTour: {
    items: [
      'Add comps',
      'Property features',
      'Date of sale adjustments',
      'Quality & effective age',
      'Subject’s market value',
      "You're done!",
    ],
    tooltipMapping: [0, 1, 1, 2, 3, 3, 3, 3, 4, 4, 5, 5, 5, 5, 5, 5],
  },
};
